import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import { fontSize } from 'components/styles'
import MenuButton from './MenuButton'


const ButtonGroup = styled.div`
  ${fontSize}
  display: flex;
  flex-direction: row;
  margin-top: 0.5em;
  margin-bottom: 0.5em;
  margin-left: 0.25em;
  margin-right: 0.25em;
`
const MenuContainer = styled.div`
  display: flex;
  flex-direction: column;
`
const MenuButtonContainer = styled.div`
  margin-left: 0.25em;
  margin-right: 0.25em;
`
// const BottomMenuBlockContainer = styled.div`
//   border-top: 1px #c6c6c6 solid;
// `

export default class PopupMenu extends Component {

  render () {
    const { buttons, activeButtonIndex, onButtonClick, renderBottomMenuBlock } = this.props
    return (
      <MenuContainer>
        <ButtonGroup>
          {buttons.map((m, i) => {
            const active = activeButtonIndex === i
            // console.log('button', i, 'is active', active)
            return (
              <MenuButtonContainer key={i}>
                <MenuButton
                  size='slim'
                  onClick={onButtonClick(i)}
                  active={active}
                >
                  {m.title}
                </MenuButton>
              </MenuButtonContainer>
            )
          })}
        </ButtonGroup>
        {renderBottomMenuBlock()}
      </MenuContainer>
    )
  }
}

PopupMenu.defaultProps = {
  buttons: [],
  activeButtonIndex: 0,
  renderBottomMenuBlock: () => null,
  onButtonClick: () => null
}

PopupMenu.propTypes = {
  buttons: PropTypes.array,
  activeButtonIndex: PropTypes.number,
  renderBottomMenuBlock: PropTypes.func,
  onButtonClick: PropTypes.func
}



// WEBPACK FOOTER //
// ./src/components/shopifyApp/shopifyWizard/shopifyOverlay/PopupMenu.js